/*
 * @Author: your name
 * @Date: 2020-04-22 14:40:14
 * @LastEditTime: 2022-05-26 18:21:21
 * @LastEditors: haima haima@yaomaitong.cn
 * @Description: In User Settings Edit
 * @FilePath: /static-kshdoctor/src/store/mutation.js
 */
import * as types from './mutation-types'

const mutation = {
	//首页
  [types.UPDATE_DOCTOR_INFO](state, res) {
		state.doctorInfo = {...state.doctorInfo,...res}
	},
	[types.SET_REPRESENT_INFO](state, info) {
		state.representInfo = info
	},
	[types.GET_DEPARTMENT_LIST](state,res){
		state.departmentList = res
	},
	//通用
	[types.SET_PAGE_TITLE](state, title) {
		state.pageTitle = title
	},
}
export default mutation
